import React, { useState, useEffect } from "react";
import {
  Monitor,
  Shield,
  // eslint-disable-next-line
  Cloud,
  // eslint-disable-next-line
  Activity,
  Settings,
  Database,
  Headphones,
  // eslint-disable-next-line
  Zap,
} from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "../Footer/Footer";
// eslint-disable-next-line
import expertIcon from "../../assets/image/itsupport/classroom_2125104.png";
import projectIcon from "../../assets/image/itsupport/time-management_15549491.png";
import careerIcon from "../../assets/image/itsupport/knowledge_12050615.png";
import handsOnIcon from "../../assets/image/itsupport/career_18058242.png";

import img3 from "../../assets/image/itsupport/img3.jpeg";
import img4 from "../../assets/image/itsupport/paper-analysis.jpg";
import img5 from "../../assets/image/itsupport/confident-call-center-operator-talking-with-client.jpg";
import img6 from "../../assets/image/itsupport/img4.jpg";
import img8 from "../../assets/image/itsupport/business-person-looking-finance-graphs.jpg";
import img7 from "../../assets/image/itsupport/5637120.jpg";
import img9 from "../../assets/image/itsupport/modern-equipped-computer-lab.jpg";
import img10 from "../../assets/image/itsupport/img10.jpeg";
import "../../assets/css/itsupport.css";

import {
  FaEnvelope,
  FaSkype,
  FaPhone,
  FaUser,
  FaGlobe,
  FaDollarSign,
  FaChartLine,
  FaPen,
  FaPaperPlane,
  FaBuilding,
  FaTimes,
} from "react-icons/fa";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { IoLogoWhatsapp, IoMdBuild } from "react-icons/io";
import emailjs from "@emailjs/browser";
import { useRef } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl";

const ITSupportSolutions = () => {
  const [meta, setMeta] = useState({});

  useEffect(() => {
    const Gamedevelopment = data[0]?.services_page_IT_Support;

    if (Gamedevelopment) {
      setMeta(Gamedevelopment);
    }
  }, []);
  const [hoveredCard, setHoveredCard] = useState(null);

  // Scroll Up
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out-cubic",
      offset: 100,
    });
  }, []);

  const itSolutions = [
    {
      id: 1,
      title: "Student Workshops & Events",
      description:
        "We organize on-campus and online workshops, bootcamps, and game jams for students to explore real industry workflows:",
      icon: "📊",
      features: [
        "Colleges & Universities",
        "IT/CS/Multimedia Departments",
        "Final-year & fresher skill-building",
      ],
      image: `${img4}`,
    },
    {
      id: 2,
      title: "Corporate Training for Tech Teams",
      description:
        " Our expert-led training is designed for companies looking to expand their capabilities in:",
      icon: "🛠️",
      features: [
        "Game Design & Development (Unity, Unreal Engine)",
        "AR/VR Development",
        "Mobile Game Programming",
        "UI/UX for Games	",
      ],
      image: `${img5}`,
    },
    // {
    //   id: 3,
    //   title: "Scalable IT Management",
    //   description:
    //     "Tailoring solutions to fit unique organizational needs, from small businesses to large enterprises.",
    //   icon: "⚡",
    //   features: [
    //     "Custom IT strategies",
    //     "Enterprise-grade solutions",
    //     "Flexible service packages",
    //   ],
    //   image: `${img6}`,
    // },
    // {
    //   id: 4,
    //   title: "Disaster Recovery & Backup",
    //   description:
    //     "Implementing robust disaster recovery and data backup plans for business continuity.",
    //   icon: "🔒",
    //   features: [
    //     "Automated backup systems",
    //     "Disaster recovery planning",
    //     "Business continuity assurance",
    //   ],
    //   image: `${img7}`,
    // },
    {
      id: 3,
      title: "Strategic IT Consulting",
      description:
        "Expert guidance on technology investments and infrastructure optimization for long-term success.",
      icon: "💡",
      features: [
        "Technology roadmapping",
        "Infrastructure optimization",
        "Strategic planning consulting",
        "Enterprise-grade solutions",
      ],
      image: `${img8}`,
    },
  ];

  const capabilities = [
    {
      icon: (
        <img src={expertIcon} alt="Expert Trainers" width={40} height={40} />
      ),
      title: "Expert Trainers",
      description:
        "Learn from seasoned industry professionals who bring real-world experience to every session.",
    },
    {
      icon: (
        <img
          src={projectIcon}
          alt="Real-Time Projects"
          width={40}
          height={40}
        />
      ),
      title: "Real-Time Projects",
      description:
        "Gain practical exposure through guided, real-time projects that simulate actual work environments.",
    },
    {
      icon: (
        <img
          src={careerIcon}
          alt="Career-Ready Approach"
          width={40}
          height={40}
        />
      ),
      title: "Career-Ready Approach",
      description:
        "Focused guidance to bridge the gap from college education to career success.",
    },
    {
      icon: (
        <img src={handsOnIcon} alt="Hands-On Learning" width={40} height={40} />
      ),
      title: "Hands-On Learning",
      description:
        "100% hands-on and outcome-based learning that ensures you're job-ready from day one.",
    },
  ];

  const techCategories = [
    {
      title: "Monitoring Tools",
      icon: "📊",
      tools: ["SolarWinds", "Datadog", "Zabbix", "Nagios"],
      description:
        "Industry-leading monitoring platforms for proactive system health tracking.",
    },
    {
      title: "Security Solutions",
      icon: "🔐",
      tools: ["Firewall Management", "Antivirus", "Endpoint Protection", "VPN"],
      description:
        "Comprehensive security measures to protect your digital infrastructure.",
    },
    {
      title: "Cloud Platforms",
      icon: "☁️",
      tools: ["AWS", "Microsoft Azure", "Google Cloud", "Office 365"],
      description:
        "Leading cloud platforms for scalable and flexible IT infrastructure.",
    },
    {
      title: "Support Tools",
      icon: "🛠️",
      tools: ["Remote Desktop", "Help Desk", "Asset Management", "Ticketing"],
      description:
        "Essential tools for efficient IT support and service management.",
    },
  ];

  const [isOpenEnquiry, setIsOpenEnquiry] = useState(false);

  const [formDataEnquiry, setFormDataEnquiry] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    companyName: "",
    companyService: "",
    serviceType: "",
    country: "",
    message: "",
  });

  const form = useRef();

  const handleClose = () => {
    setIsOpenEnquiry(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDataEnquiry((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_z73r4mc",
        "template_evcmg1l",
        form.current,
        "EscxBRJBS9wDUay2E"
      )
      .then(
        (result) => {
          alert("Enquiry sent successfully!");
          setIsOpenEnquiry(false);
          setFormDataEnquiry({
            name: "",
            email: "",
            phone: "",
            whatsapp: "",
            companyName: "",
            companyService: "",
            serviceType: "",
            country: "",
            message: "",
          });
        },
        (error) => {
          console.error("Failed to send email:", error.text);
          alert("Failed to send enquiry. Please try again.");
        }
      );
  };

  const inputStyle = {
    width: "100%",
    padding: "8px 10px",
    border: "2px solid #e9ecef",
    borderRadius: "10px",
    fontSize: "0.95rem",
    background: "white",
    outline: "none",
    transition: "all 0.3s ease",
  };

  return (
    <HelmetProvider>
      <div className="it-support-website">
        <Helmet>
          <title>{meta?.title || "Services-IT_Support  - SHIV NEXTGEN TECHNOLOGIES PRIVATE LIMITED"}</title>
          <meta
            name="description"
            content={meta?.meta?.meta1?.content || "Our curriculum."}
          />
        </Helmet>
        {/* Enquiry Form */}
        {isOpenEnquiry && (
          <div
            onClick={handleBackdropClick}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.6)",
              backdropFilter: "blur(8px)",
              zIndex: 1050,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "650px",
                maxHeight: "100vh",
                background: "#fff",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 15px 50px rgba(0,0,0,0.25)",
              }}
            >
              {/* Fixed Header */}
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#41C1EE",
                  color: "#ffffff",
                  padding: "15px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  zIndex: 2,
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    textAlign: "center",
                  }}
                >
                  Enquiry Form
                </h3>
                <button
                  onClick={handleClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#ffffff",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  <FaTimes />
                </button>
              </div>

              {/* Scrollable Form */}
              <div
                style={{
                  padding: "20px",
                  overflowY: "auto",
                  maxHeight: "calc(100vh - 70px)", // Adjust based on header height
                }}
              >
                <form ref={form} onSubmit={handleSubmitForm}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(250px, 1fr))",
                      gap: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    {/* Full Name */}
                    <div>
                      <FaUser
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formDataEnquiry.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter full name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Email */}
                    <div>
                      <FaEnvelope
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formDataEnquiry.email}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter email"
                        style={inputStyle}
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <FaPhone
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formDataEnquiry.phone}
                        onChange={handleInputChange}
                        placeholder="Enter phone"
                        style={inputStyle}
                      />
                    </div>

                    {/* WhatsApp */}
                    <div>
                      <IoLogoWhatsapp
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">WhatsApp</label>
                      <input
                        type="tel"
                        name="whatsapp"
                        value={formDataEnquiry.whatsapp}
                        onChange={handleInputChange}
                        placeholder="Enter WhatsApp"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Name */}
                    <div>
                      <FaBuilding
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Name</label>
                      <input
                        type="text"
                        name="companyName"
                        value={formDataEnquiry.companyName}
                        onChange={handleInputChange}
                        placeholder="Enter company name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Service */}
                    <div>
                      <IoMdBuild
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Service</label>
                      <select
                        name="companyService"
                        value={formDataEnquiry.companyService}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Solo">Solo</option>
                        <option value="Pvt">Pvt</option>
                        <option value="LLP">LLP</option>
                        <option value="Startup">Startup</option>
                        <option value="Partnership">Partnership</option>
                      </select>
                    </div>

                    {/* Service Type */}
                    <div>
                      <MdOutlineMiscellaneousServices
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Type of Service</label>
                      <select
                        name="serviceType"
                        value={formDataEnquiry.serviceType}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Software">Software Development</option>
                        <option value="App">App Development</option>
                        <option value="Game">Game Development</option>
                        <option value="Website">Website Development</option>
                        <option value="AR & VR Development">
                          AR & VR Apps
                        </option>
                        <option value="Casino Api">Casino API</option>
                        <option value="Devops Solutions">DevOps</option>
                        <option value="It Support">IT Support</option>
                        <option value="Training Programs">Training</option>
                        <option value="Digital Marketing">
                          Digital Marketing
                        </option>
                      </select>
                    </div>

                    {/* Country */}
                    <div>
                      <FaGlobe
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Country</label>
                      <input
                        type="text"
                        name="country"
                        value={formDataEnquiry.country}
                        onChange={handleInputChange}
                        placeholder="Enter country"
                        style={inputStyle}
                      />
                    </div>
                  </div>

                  {/* Message */}
                  <div>
                    <label className="fw-bold">Your Message *</label>
                    <textarea
                      name="message"
                      value={formDataEnquiry.message}
                      onChange={handleInputChange}
                      required
                      rows={1}
                      placeholder="Tell us about your requirements..."
                      style={{
                        ...inputStyle,
                        resize: "vertical",
                      }}
                    />
                  </div>

                  {/* Submit Button */}
                  <div
                    className="mt-1 margin-top-home"
                    style={{ textAlign: "center" }}
                  >
                    <button
                      type="submit"
                      style={{
                        background: "#41C1EE",
                        color: "white",
                        padding: "10px 20px",
                        borderRadius: "25px",
                        fontWeight: "600",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <FaPaperPlane style={{ marginRight: "8px" }} />
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Hero Section */}
        <section className="position-relative min-vh-50 itsupport-bg d-flex align-items-center justify-content-center text-white">
          <div className="it-hero-content container position-relative">
            <div className="row align-items-center">
              <div className="col-lg-9">
                <nav
                  aria-label="breadcrumb"
                  className="mb-4"
                  data-aos="fade-down"
                  data-aos-delay="200"
                >
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        className="text-white fw-bold text-decoration-none"
                      >
                        <h6>Home</h6>
                      </a>
                    </li>
                    <li
                      className="breadcrumb-item fw-bold active text-white"
                      aria-current="page"
                    >
                      <h6>IT Support & Solutions</h6>
                    </li>
                  </ol>
                </nav>
                <h3
                  className="display-5 fw-bold mb-4 text-white"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  IT Support & Solutions
                </h3>
              </div>
            </div>
          </div>
        </section>

        {/* Tech Problems Section */}
        <div className="container my-5">
          <div className="row align-items-center">
            {/* Text Section */}
            <div
              className="col-12 col-sm-6 order-1 text-center text-sm-start"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              {/* Heading + Button */}
              <div className="mb-3">
                <button
                  className="btn border d-inline-flex border-danger fw-semibold bg-transparent px-3 py-1 rounded-pill fs-6 fs-md-5"
                  style={{ color: "#41C1EE" }}
                >
                  OUR IT SUPPORT
                </button>
                <h3 className="display-6 fw-bold mt-2">
                  Building Game-Ready Skills for{" "}
                  <span className="font-red">Teams and Future Talent</span>
                </h3>
              </div>

              {/* Paragraph */}
              <p className="font-para mb-4">
                At SHIV NEXTGEN TECHNOLOGIES PRIVATE LIMITED, we don’t just develop games — we help teams and
                students build the skills to create them. From corporate
                upskilling to student workshops, our training services are
                designed to bridge the gap between creativity, coding, and
                career success.
              </p>

              {/* Buttons */}
              <div
                className="d-flex flex-column flex-sm-row justify-content-center justify-content-sm-start gap-3"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <button
                  className="btn btn-red text-white fw-semibold px-4 py-2"
                  onClick={() => setIsOpenEnquiry(true)}
                >
                  Instant Support
                </button>
              </div>
            </div>

            {/* Image Section */}
            <div
              className="col-12 col-sm-6 order-2 text-center position-relative mt-4 mt-sm-0"
              data-aos="fade-left"
              data-aos-delay="300"
            >
              <img
                src={img3}
                alt="Team working on tech support"
                className="img-fluid rounded-4 w-100"
                style={{ maxHeight: "300px", objectFit: "cover" }}
              />

              {/* Gear Icon */}
              <div
                className="position-absolute bg-danger rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: "50px",
                  height: "50px",
                  top: "-15px",
                  right: "15px",
                }}
                data-aos="zoom-in"
                data-aos-delay="600"
              >
                <i className="bi bi-gear-fill text-white fs-4"></i>
              </div>

              {/* Play Button */}
              <div
                className="position-absolute bg-danger rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: "60px",
                  height: "60px",
                  bottom: "-30px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
                data-aos="zoom-in"
                data-aos-delay="700"
              >
                <i className="bi bi-play-fill text-white fs-2"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Main Solutions Section */}
        <section className="py-4">
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <h3 className="display-5 fw-bold text-dark mb-3">
                Corporate Training{" "}
                <span className="font-red">& Student Events</span>
              </h3>
              <p className="font-para">
                Comprehensive IT services designed to prevent downtime, enhance
                performance, and safeguard your critical data.
              </p>
            </div>

            <div className="row g-4 align-items-stretch justify-content-center">
              {itSolutions.map((solution, index) => (
                <div
                  key={solution.id}
                  className="col-lg-4 col-md-6 d-flex"
                  data-aos="fade-up"
                  data-aos-delay={index * 100 + 200}
                >
                  <div
                    className="card border-0 shadow-lg w-100 h-100 solution-card position-relative overflow-hidden"
                    style={{
                      transform:
                        hoveredCard === index
                          ? "translateY(-10px)"
                          : "translateY(0)",
                      transition: "0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={() => setHoveredCard(index)}
                    onMouseLeave={() => setHoveredCard(null)}
                  >
                    <img
                      src={solution.image}
                      className="card-img-top"
                      alt={solution.title}
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <div className="card-body p-4 d-flex flex-column justify-content-between">
                      <div>
                        <div className="d-flex align-items-center mb-3">
                          <div className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-primary bg-opacity-10 p-2">
                            <span className="fs-3">{solution.icon}</span>
                          </div>
                          <h5 className="fw-bold mb-0 text-dark">
                            {solution.title}
                          </h5>
                        </div>
                        <p
                          className="mb-4"
                          style={{ fontSize: "1.05rem", fontWeight: "450" }}
                        >
                          {solution.description}
                        </p>
                      </div>

                      <div className="mb-3">
                        {solution.features.map((feature, idx) => (
                          <div
                            key={idx}
                            className="d-flex align-items-center mb-2"
                          >
                            <span className="bg-opacity-10 text-success me-2">
                              ✓
                            </span>
                            <small className="text-dark fw-medium">
                              {feature}
                            </small>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Capabilities Section */}
        <section className="py-4 bg-light">
          <div className="container">
            <div className="row align-items-center gy-4">
              {/* Capabilities Content - Appear first on mobile/tab */}
              <div className="col-lg-8 order-1 order-lg-2">
                <div className="ps-lg-5">
                  <h3
                    className="display-5 fw-bold mb-4 text-center text-lg-start"
                    data-aos="fade-up"
                    data-aos-delay="300"
                  >
                    Our IT Support
                    <span className="font-red"> Capabilities</span>
                  </h3>
                  <div className="row g-4">
                    {capabilities.map((capability, index) => (
                      <div
                        key={index}
                        className="col-12 col-md-6"
                        data-aos="fade-up"
                        data-aos-delay={index * 100 + 400}
                      >
                        <div className="capability-card p-4 bg-white rounded-3 shadow-sm h-100">
                          <div className="d-flex align-items-start gap-3">
                            <div className="icon-container d-flex align-items-center justify-content-center bg-primary bg-opacity-10 rounded-3 p-3">
                              <div className="text-danger fs-4">
                                {capability.icon}
                              </div>
                            </div>
                            <div>
                              <h5 className="fw-bold text-danger mb-2">
                                {capability.title}
                              </h5>
                              <p className="text-dark fw-medium mb-0">
                                {capability.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Image - Appear last on mobile/tab */}
              <div
                className="col-lg-4 text-center order-2 order-lg-1"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <img
                  src={img9}
                  alt="IT Support Team"
                  className="img-fluid rounded-3"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          </div>
        </section>

        <div data-aos="fade-up" data-aos-delay="200"></div>

        <style>{`
          @import url("https://fonts.googleapis.com/css2?family=Rajdhani:wght@300;400;500;600;700&display=swap");

          .it-support-website {
            font-family: "Rajdhani", sans-serif;
          }

          .it-support-website * {
            font-family: "Rajdhani", sans-serif;
          }

          .it-hero-bg {
            position: relative;
            background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
            min-height: 60vh;
          }

          .it-hero-bg::before {
            content: "";
            position: absolute;
            inset: 0;
            background-image: url("https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2000&q=80");
            background-size: cover;
            background-position: center;
            opacity: 0.3;
            z-index: 0;
          }

          .it-hero-content {
            position: relative;
            z-index: 1;
          }

          .solution-card {
            transition: all 0.3s ease;
          }

          .solution-card:hover {
            transform: translateY(-10px) !important;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15) !important;
          }

          .capability-card {
            transition: all 0.3s ease;
            border: 1px solid transparent;
          }

          .capability-card:hover {
            transform: translateY(-5px);
            border-color: rgba(13, 110, 253, 0.2);
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
          }

          .icon-container {
            width: 80px;
            height: 80px;
            transition: all 0.3s ease;
          }

          .capability-card:hover .icon-container {
            background: rgba(13, 110, 253, 0.15) !important;
            transform: scale(1.1);
          }

          .tech-card {
            transition: all 0.3s ease;
          }

          .tech-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
          }

          .cta-bg {
            background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
            position: relative;
          }

          .cta-bg::before {
            content: "";
            position: absolute;
            inset: 0;
            background-image: url("=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2000&q=80");
            background-size: cover;
            background-position: center;
            opacity: 0.2;
            z-index: 0;
          }

          .z-1 {
            z-index: 1;
          }

          .btn-primary {
            background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
            border: none;
            transition: all 0.3s ease;
            font-family: "Rajdhani", sans-serif;
            font-weight: 600;
          }

          .btn-primary:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
            transform: translateY(-2px);
            box-shadow: 0 10px 20px rgba(59, 130, 246, 0.3);
          }

          .btn-outline-light:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 20px rgba(255, 255, 255, 0.2);
          }

          .btn-outline-secondary {
            font-family: "Rajdhani", sans-serif;
            font-weight: 600;
          }

          h1,
          h2,
          h3,
          h4,
          h5,
          h6 {
            font-family: "Rajdhani", sans-serif;
            font-weight: 600;
          }

          .display-4,
          .display-5 {
            font-family: "Rajdhani", sans-serif;
            font-weight: 700;
          }

          .lead {
            font-family: "Rajdhani", sans-serif;
            font-weight: 400;
          }

          .card-title {
            font-family: "Rajdhani", sans-serif;
            font-weight: 600;
          }

          .card-text {
            font-family: "Rajdhani", sans-serif;
            font-weight: 400;
          }

          .breadcrumb-item a {
            font-family: "Rajdhani", sans-serif;
            font-weight: 500;
          }

          .badge {
            font-family: "Rajdhani", sans-serif;
            font-weight: 500;
          }

          /* AOS Animation Enhancements */
          [data-aos] {
            pointer-events: none;
          }

          [data-aos].aos-animate {
            pointer-events: auto;
          }

          /* Custom AOS animations for badges */
          .tech-tools .badge {
            opacity: 0;
            transform: scale(0.8);
            transition: all 0.3s ease;
          }

          .tech-tools .badge.aos-animate {
            opacity: 1;
            transform: scale(1);
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .display-4 {
              font-size: 2.5rem;
            }

            .display-5 {
              font-size: 2rem;
            }

            .lead {
              font-size: 1.1rem;
            }

            .it-hero-bg {
              min-height: 50vh;
            }

            .capability-card .row {
              text-align: center;
            }

            .capability-card .col-auto {
              margin-bottom: 1rem;
            }

            .btn-lg {
              font-size: 1rem;
              padding: 0.75rem 2rem;
            }
          }

          @media (max-width: 576px) {
            .container-fluid {
              padding-left: 1rem;
              padding-right: 1rem;
            }

            .display-4 {
              font-size: 2rem;
            }

            .ps-lg-5 {
              padding-left: 0 !important;
            }

            .tech-tools .badge {
              font-size: 0.8rem;
            }
          }
        `}</style>

        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default ITSupportSolutions;
